export enum EmployeePages {
    START = 'Start',
    YOUR_INFO = 'Your info',
    CONTACT_INFO = 'Contact info',
    EMPLOYER = 'Employer',
    RELATIONSHIP = 'Relationship',
    CHILD_SUPPORT = 'Child support',
    CLAIM_DATES = 'Claim dates',
    CLAIM_TYPE = 'Claim type',
    HIPAA = 'HIPAA',
    TREATING_PHYSICIAN = 'Treating physician',
    DOCUMENT = 'Document',
    BENEFITS = 'Benefits',
    PAYMENTS = 'Payments',
    SUMMARY = 'Summary',
    FINISH = 'Finish'
}